import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Youtube, Mail, MapPin, Phone, Clock } from 'lucide-react';
import { BsTwitterX } from 'react-icons/bs';
import arcaLogo from '../../assets/arca_logo.png';

const PublicFooter = () => {
  return (
    <footer style={{ backgroundColor: '#1f2937' }} className="text-white">
      <div className="container-fluid px-4 px-md-5 py-5">
        <div className="row g-4 justify-content-between">
          {/* About Section with Logo */}
          <div className="col-lg-3 col-md-6">
            <div className="mb-3">
              <img src={arcaLogo} alt="ARCA Logo" style={{ height: '60px', width: 'auto' }} className="mb-3" />
            </div>
            <h5 className="fw-bold mb-3" style={{ color: '#6B8E23' }}>About ARCA</h5>
            <p style={{ color: '#d1d5db', fontSize: '0.875rem' }}>
              Africa Respiratory Care Association (ARCA) is a Pan-African healthcare organization
              dedicated to strengthening respiratory care education, practice, and research across Africa.
            </p>
            <div className="d-flex gap-3 mt-3">
              <a href="https://rb.gy/pzwavg" target="_blank" rel="noopener noreferrer"
                className="text-white" style={{ transition: 'color 0.2s' }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                onMouseLeave={(e) => e.currentTarget.style.color = 'white'}>
                <Facebook size={20} />
              </a>
              <a href="https://x.com/AfricaResp" target="_blank" rel="noopener noreferrer"
                className="text-white" style={{ transition: 'color 0.2s' }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                onMouseLeave={(e) => e.currentTarget.style.color = 'white'}>
                <BsTwitterX size={20} />
              </a>
              <a href="https://shorturl.at/2jZek" target="_blank" rel="noopener noreferrer"
                className="text-white" style={{ transition: 'color 0.2s' }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                onMouseLeave={(e) => e.currentTarget.style.color = 'white'}>
                <Linkedin size={20} />
              </a>
              <a href="https://www.instagram.com/africaresp?igsh=bzJtMmwwb3Z3Zmhk&utm_source=qr" target="_blank" rel="noopener noreferrer"
                className="text-white" style={{ transition: 'color 0.2s' }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                onMouseLeave={(e) => e.currentTarget.style.color = 'white'}>
                <Instagram size={20} />
              </a>
              <a href="https://www.youtube.com/@Africaresp" target="_blank" rel="noopener noreferrer"
                className="text-white" style={{ transition: 'color 0.2s' }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                onMouseLeave={(e) => e.currentTarget.style.color = 'white'}>
                <Youtube size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-6">
            <h5 className="fw-bold mb-3" style={{ color: '#6B8E23' }}>Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/about" style={{ color: '#d1d5db', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.2s' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#d1d5db'}>
                  About Us
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/programs/education-training" style={{ color: '#d1d5db', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.2s' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#d1d5db'}>
                  Programs
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/chapters" style={{ color: '#d1d5db', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.2s' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#d1d5db'}>
                  Chapters
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/events" style={{ color: '#d1d5db', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.2s' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#d1d5db'}>
                  Events
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/news" style={{ color: '#d1d5db', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.2s' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#d1d5db'}>
                  News & Stories
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/contact" style={{ color: '#d1d5db', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.2s' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#d1d5db'}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Get Involved */}
          <div className="col-lg-2 col-md-6">
            <h5 className="fw-bold mb-3" style={{ color: '#6B8E23' }}>Get Involved</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/get-involved/become-member" style={{ color: '#d1d5db', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.2s' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#d1d5db'}>
                  Become a Member
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/get-involved/volunteer" style={{ color: '#d1d5db', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.2s' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#d1d5db'}>
                  Volunteer
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/get-involved/vendor-membership" style={{ color: '#d1d5db', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.2s' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#d1d5db'}>
                  Vendor Membership
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/get-involved/partner" style={{ color: '#d1d5db', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.2s' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#d1d5db'}>
                  Partner with Us
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/get-involved/donate"
                  style={{ color: '#d1d5db', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.2s' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#d1d5db'}
                >
                  Donate
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div className="col-lg-4 col-md-6">
            <h5 className="fw-bold mb-3" style={{ color: '#6B8E23' }}>Contact Us</h5>

            {/* USA Address */}
            <div className="mb-3">
              <div className="d-flex align-items-start mb-2">
                <MapPin className="me-2 mt-1" size={16} style={{ color: '#60a5fa', flexShrink: 0 }} />
                <div>
                  <p className="mb-0 fw-semibold" style={{ color: '#f3f4f6', fontSize: '0.875rem' }}>USA Office</p>
                  <p className="mb-0" style={{ color: '#d1d5db', fontSize: '0.813rem' }}>
                    235 Peachtree Street NE Suite 400,<br />
                    Atlanta, GA, 30303
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-start mb-2 ms-4">
                <Phone className="me-2 mt-1" size={14} style={{ color: '#6B8E23', flexShrink: 0 }} />
                <p className="mb-0" style={{ color: '#d1d5db', fontSize: '0.813rem' }}>
                  +1(952)228-1482
                </p>
              </div>
            </div>

            {/* Ghana Address */}
            <div className="mb-3">
              <div className="d-flex align-items-start mb-2">
                <MapPin className="me-2 mt-1" size={16} style={{ color: '#60a5fa', flexShrink: 0 }} />
                <div>
                  <p className="mb-0 fw-semibold" style={{ color: '#f3f4f6', fontSize: '0.875rem' }}>Ghana Office</p>
                  <p className="mb-0" style={{ color: '#d1d5db', fontSize: '0.813rem' }}>
                    13 MANSTE AFOTEY ADZIN II RD,<br />
                    GT-373-9745, Tema Metropolis,<br />
                    Greater Accra Region
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-start mb-2 ms-4">
                <Phone className="me-2 mt-1" size={14} style={{ color: '#6B8E23', flexShrink: 0 }} />
                <p className="mb-0" style={{ color: '#d1d5db', fontSize: '0.813rem' }}>
                  +233(0)24 213 0397
                </p>
              </div>
            </div>

            {/* Email */}
            <div className="d-flex align-items-start mb-2">
              <Mail className="me-2 mt-1" size={16} style={{ color: '#6B8E23', flexShrink: 0 }} />
              <div>
                <a href="mailto:info@africaresp.org" style={{ color: '#d1d5db', textDecoration: 'none', fontSize: '0.875rem' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#d1d5db'}>
                  info@africaresp.org
                </a>
              </div>
            </div>

            {/* Working Hours */}
            <div className="d-flex align-items-start">
              <Clock className="me-2 mt-1" size={16} style={{ color: '#6B8E23', flexShrink: 0 }} />
              <div>
                <p className="mb-0" style={{ color: '#d1d5db', fontSize: '0.875rem' }}>
                  Mon - Fri: 8:00am - 4:30pm
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-5 pt-4" style={{ borderTop: '1px solid #374151' }}>
          <div className="row align-items-center">
            <div className="col-md-4 text-center text-md-start mb-3 mb-md-0">
              <p className="mb-0" style={{ color: '#9ca3af', fontSize: '0.875rem' }}>
                &copy; {new Date().getFullYear()} Africa Respiratory Care Association. All rights reserved.
              </p>
            </div>
            <div className="col-md-4 text-center mb-3 mb-md-0">
              <p className="mb-0" style={{ color: '#9ca3af', fontSize: '0.875rem' }}>
                Designed by:{' '}
                <a
                  href="https://rissatech.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#60a5fa', textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#93c5fd'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#60a5fa'}
                >
                  RissaTech Nova
                </a>
              </p>
            </div>
            <div className="col-md-4">
              <div className="d-flex justify-content-center justify-content-md-end gap-4">
                <Link to="/privacy-policy" style={{ color: '#9ca3af', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.2s' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#9ca3af'}>
                  Privacy Policy
                </Link>
                <Link to="/terms-conditions" style={{ color: '#9ca3af', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.2s' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#6B8E23'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#9ca3af'}>
                  Terms & Conditions
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
